<!-- @format -->

<template>
	<div class="recruit-canvas">
		<div ref="canvasRef" class="canvas-box">
			<canvas ref="canvasMapRef" class="canvas-map" />
		</div>

		<div class="btn-box flex-row">
			<el-button type="primary" @click="handleConfirm">保存</el-button>
			<el-button @click="clearHandle">重置</el-button>
			<el-button @click="cancelHandle">取消</el-button>
		</div>
	</div>
</template>

<script lang="ts" setup>
	import SignaturePad from 'signature_pad';
	import { rotateBase64Img } from './common';

	const canvasNode = ref<any>();

	const emit = defineEmits(['confirmEvent', 'cancelEvent']);
	const canvasRef = ref();
	const canvasMapRef = ref();

	onMounted(() => {
		nextTick(() => {
			initalHandle();
			window.addEventListener('resize', initalHandle, false);
		});
	});

	onBeforeUnmount(() => {
		window.removeEventListener('resize', initalHandle, false);
	});

	const initalHandle = () => {
		const _canvasBox = canvasRef.value;
		const _canvas = canvasMapRef.value;
		if (!_canvasBox || !_canvas) {
			console.warn('DOM节点初始化失败');
			return false;
		}

		_canvas.width = _canvasBox.clientWidth;
		_canvas.height = _canvasBox.clientHeight;
		const computedOpt = Object.assign(
			{},
			{
				minWidth: 2,
				maxWidth: 2,
				penColor: 'rgb(0, 0, 0)',
			},
			{},
		);

		clearHandle();
		canvasNode.value = new SignaturePad(_canvas, computedOpt);
	};

	const clearHandle = () => {
		const hasNode = canvasNode.value;
		if (hasNode) {
			hasNode.clear();
		}
	};

	const cancelHandle = () => {
		emit('cancelEvent');
	};

	const handleConfirm = () => {
		if (!canvasNode.value) {
			initalHandle();
		}

		// 是否签字
		if (canvasNode.value.isEmpty()) {
			ElMessage.warning('您还没有签名');
			emit('confirmEvent', '');
		} else {
			// 图像旋转二次处理
			const _boxWidth = window.innerWidth;
			const _boxHeight = window.innerHeight;
			const _signImg = canvasNode.value.toDataURL('image/png', 0.6) || null;
			if (_boxWidth < _boxHeight) {
				rotateBase64Img(_signImg, -90, (imgUrlRes) => {
					emit('confirmEvent', imgUrlRes);
				});
			} else {
				emit('confirmEvent', _signImg);
			}
		}
	};
</script>

<style lang="scss" scoped>
	.recruit-canvas {
		position: fixed;
		top: 0;
		left: 0;
		width: 100%;
		height: 100%;

		.canvas-box,
		.btn-box {
			position: absolute;
			top: 50%;
			z-index: 100;
			left: -12%;
		}

		.canvas-box {
			left: 22%;
			width: 70vw;
			height: 80vh;
			overflow: hidden;
			transform: translateY(-50%);
			background-color: #fff;
			border: 1px dashed #d4d4d4;

			.canvas-map {
				width: 100%;
				height: 100%;
			}
		}

		.btn-box {
			z-index: 10000;
			text-align: center;
			transform: rotate(90deg);
		}
	}

	@media screen and (orientation: portrait) {
		/* 竖屏 css */
	}

	@media screen and (orientation: landscape) {
		/* 横屏 css */
		.recruit-canvas {
			.canvas-box {
				top: 10%;
				left: 10%;
				width: 80vw;
				height: 70vh;
				transform: translateY(0);
			}

			.btn-box {
				width: 60%;
				top: 85%;
				left: 20%;
				transform: rotate(0);
			}
		}
	}
</style>
